/**
 * @file Network status related constants.
 */

/**
 * Apollo network status.
 *
 * @see https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-query-data-networkStatus.
 *
 * @enum APOLLO_NETWORK_STATUS
 * @type {{LOADING: number, READY: number, POLL: number, ERROR: number, FETCH_MORE: number, SET_VARIABLES: number, REFETCH: number}}
 */
const APOLLO_NETWORK_STATUS = {
  LOADING: 1,
  SET_VARIABLES: 2,
  FETCH_MORE: 3,
  REFETCH: 4,
  POLL: 6,
  READY: 7,
  ERROR: 8,
};

/**
 * Given a network status it determines whether a query is in flight.
 *
 * @param {APOLLO_NETWORK_STATUS} networkStatus - The network status.
 * @returns {boolean}
 */
const apolloNetworkRequestInFlight = networkStatus => networkStatus < 7;

export { APOLLO_NETWORK_STATUS, apolloNetworkRequestInFlight };
